<template>
    <div class="row">
      <div class="col-md-4">
      </div>
        <div class="col-lg-3 col-md-4" style="text-align: center;">
            <div class="login-panel panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Qr Code Activation Required</h3>
                </div>
                <div class="panel-body">
                    <form role="form">
                        <fieldset>
                          <div class="form-group">
                            <h1>
                                <small>{{ countDown }}</small>
                            </h1>

                          </div>
                            <div class="form-group">
                              <br> <vue-qr  :text="secr" :size="200"></vue-qr>
                            </div>
                            <div class="form-group">
                              DBA Sytem admin to login powerlifefilters V1.0
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
            <div>
            </div>
        </div>
    </div>
</template>
<style >
#inner {
display: table;
margin: 0 auto;
border: 1px solid black;
}

#outer {
border: 1px solid red;
width:100%
}
</style>
<script>
import axios from 'axios'
import VueQr from 'vue-qr'
export default {
  name: 'MobileActive',
  components: {VueQr},
  data () {
    return {
      secr: 'as6d4f3231wer54fsd6f8e',
      countDown: 60,
      istimer: true
    }
  },
  created () {
    this.countDownTimer()
  },
  methods: {
    countDownTimer () {
      if (this.countDown > 0 && this.istimer) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
          axios.post(this.$apiURL + 'auth/mobile-check-active', {
            token: localStorage.getItem('token')
          })
            .then(res => {
              if (res.data[0].action_date < 60) {
                this.istimer = false
                this.$router.push('/dashborad')
              }
            })
          if (this.countDown === 0) {
            this.$router.push('/login')
          }
        }, 1000)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myComponents/MobileActive.vue